export const FilterUnivers = (parks, id) => {
    let univers;
    if (parks.length > 0) {
        for (const park of parks) {
            for (const el of park.univers) {
                if (el.uid === id) {
                    univers = {
                        uid: el.uid,
                        uname: el.uname,
                        uslug: el.uslug,
                        uroute: el.uroute,
                    };
                }
            }
        }
        return univers;
    }
}